import { render, staticRenderFns } from "./MyBox.vue?vue&type=template&id=81858cc4&"
import script from "./MyBox.vue?vue&type=script&lang=js&"
export * from "./MyBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports